import {
  Target,
  Users,
  Trophy,
  Sparkles,
  BookOpen,
  Rocket,
  Mountain,
  Star,
  Crown,
  Flame,
  Heart,
  Shield,
  Compass,
  Map,
  Flag,
  Award,
  Gift,
  Sun,
  Moon,
  Cloud,
  Droplet,
  Wind,
  Eye,
  Brain,
  Bolt,
  Diamond,
  Gem,
  Puzzle,
  Building2,
  UserCheck,
  Briefcase,
  Code,
  Palette,
  Music,
  GraduationCap,
  TrendingUp,
  Lightbulb,
  Zap,
  Calendar,
  type LucideIcon,
} from "lucide-react";

const ICON_MAP: Record<string, LucideIcon> = {
  mountain: Mountain,
  target: Target,
  rocket: Rocket,
  trophy: Trophy,
  star: Star,
  crown: Crown,
  flame: Flame,
  heart: Heart,
  shield: Shield,
  compass: Compass,
  map: Map,
  flag: Flag,
  award: Award,
  gift: Gift,
  sparkles: Sparkles,
  sun: Sun,
  moon: Moon,
  cloud: Cloud,
  droplet: Droplet,
  wind: Wind,
  eye: Eye,
  brain: Brain,
  bolt: Bolt,
  diamond: Diamond,
  gem: Gem,
  puzzle: Puzzle,
  building2: Building2,
  users: Users,
  usercheck: UserCheck,
  briefcase: Briefcase,
  code: Code,
  palette: Palette,
  music: Music,
  bookopen: BookOpen,
  book: BookOpen,
  graduationcap: GraduationCap,
  trendingup: TrendingUp,
  trending: TrendingUp,
  lightbulb: Lightbulb,
  idea: Lightbulb,
  zap: Zap,
  calendar: Calendar,
};

export function getTempleIcon(iconName: string | null | undefined): LucideIcon {
  if (!iconName) return Target;
  return ICON_MAP[iconName.toLowerCase()] || Target;
}

export function getAchievementIcon(iconName: string): LucideIcon {
  return ICON_MAP[iconName.toLowerCase()] || Trophy;
}
